import React, { useEffect, useState } from "react";
import "./style.css";
import { useSelector } from "react-redux";
import { Button, Typography, InputAdornment } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import SearchIcon from "@material-ui/icons/Search";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import GstrFilingModal from "../../../components/Modals/GstinFilingModal/GstinFilingModal";
import { CustomTextField } from "../utility";

const headers = [
  "GSTIN of ECO",
  "POS",
  "GSTIN of Supplier",
  "Name of Supplier",
  "Status of Recipient",
  "Gross Value of Supplies Made",
  "Value of Supplies Returned",
  "Net Amount liable to TCS",
  "IGST",
  "CGST",
  "SGST",
];

const Table3 = (props) => {
  const [search, setSearch] = useState("");
  const [showGstinFillingModal, setShowGstinFillingModal] = useState(false);
  const [selectedGstin, setSelectedGstin] = useState("");

  const selectedPeriodSingle = useSelector(
    (store) => store.gstr8PrepareDataReducer.selectedPeriodSingle
  );

  const formatAmount = (v) => {
    if (v === null || v === undefined || v === "" || isNaN(Number(v))) return "--";
    return Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const openGstinFilingModal = (gstin) => {
    setSelectedGstin(gstin);
    setShowGstinFillingModal(true);
  };


  useEffect(() => {
    console.log("Fetching data for supType:", props.viewTabData);
  }, []);

  // Flatten data and group by GSTIN of Supplier for row merging
  const flattenedData = [];
  if (props.viewTabData && props.viewTabData.length > 0) {
    props.viewTabData.forEach((row, idx) => {
      if (row.data_json && row.data_json.length > 0) {
        row.data_json.forEach((sinData, dataIdx) => {
          flattenedData.push({
            ...sinData,
            rowIdx: idx,
            dataIdx: dataIdx,
            supplierGstin: sinData.stin || sinData.gstin || "--",
          });
        });
      }
    });
  }

  // Group by supplier GSTIN to calculate rowSpan
  const supplierGroups = {};
  flattenedData.forEach((item, index) => {
    const key = item.supplierGstin;
    if (!supplierGroups[key]) {
      supplierGroups[key] = { firstIndex: index, count: 0, firstItem: item };
    }
    supplierGroups[key].count++;
  });

  const rows = flattenedData.map((sinData, index) => {
    const supplierGstin = sinData.supplierGstin;
    const group = supplierGroups[supplierGstin];
    const isFirstInGroup = group.firstIndex === index;

    return (
      <tr key={`${sinData.rowIdx}-${sinData.dataIdx}`} className={sinData.rowIdx % 2 === 0 ? "even" : "odd"}>
        <td className="text-left">{sinData.gstinECO || sinData.gstin || "--"}</td>
        <td className="numeric">{sinData.pos || sinData.place_of_supply || "--"}</td>
        <td className="text-left">
          {supplierGstin}&nbsp;&nbsp;&nbsp;
          <svg
            onClick={() => openGstinFilingModal(supplierGstin)}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            color="rgba(0, 167, 181, 1)"
            fill="currentColor"
            className="bi bi-box-arrow-up-right"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
            />
            <path
              fillRule="evenodd"
              d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
            />
          </svg>
        </td>
        <td className="text-left">{sinData.LN || sinData.name || sinData.supplierName || sinData.supName || "--"}</td>
        <td className="text-left">{sinData.recipientStatus || sinData.status || sinData.recipient || "--"}</td>
        <td className="numeric">{formatAmount(sinData.grossValSup)}</td>
        <td className="numeric">{formatAmount(sinData.valSup)}</td>
        <td className="numeric">{formatAmount(sinData.netAmtSup)}</td>
        {isFirstInGroup && (
          <>
            <td className="numeric" rowSpan={group.count}>{formatAmount(group.firstItem.igst)}</td>
            <td className="numeric" rowSpan={group.count}>{formatAmount(group.firstItem.cgst)}</td>
            <td className="numeric" rowSpan={group.count}>{formatAmount(group.firstItem.sgst)}</td>
          </>
        )}
      </tr>
    );
  });
  return (
    <div className="table3-container">
      <div className="table3-controls">
        <div className="table3-controls-left">
          <Button
            onClick={() => props.setShowViewTab(false)}
            variant="outlined"
            color="primary"
            startIcon={<ArrowBackIosIcon />}
            className="table3-backbtn"
          >
            Back
          </Button>
          <div className="span-text">3. Details of Supplies attracting TCS</div>
        </div>
        <div className="table3-controls-right">
          <div className="search-custom">
            <CustomTextField
              placeholder="Search"
              variant="outlined"
              size="small"
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.getViewTableData(props.supType, search)}
            className="table3-searchbtn"
          >
            Search
          </Button>
        </div>
      </div>

      <div className="tableWrapper">
        <table className="gst-table">
          <thead>
            <tr>
              {headers.map((h) => (
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows && rows.length > 0 ? (
              rows
            ) : (
              <tr>
                <td colSpan={headers.length} className="no-data">
                  No Data Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Dialog aria-labelledby="customized-dialog-title" fullWidth={true} maxWidth="sm" open={showGstinFillingModal}>
        <MuiDialogTitle disableTypography style={{ backgroundColor: "#4f2d7f", color: "white" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h6">{"GSTIN/Filing Status"}</Typography>
            <CloseIcon onClick={() => setShowGstinFillingModal(false)} color="white" style={{ cursor: "pointer" }} />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <GstrFilingModal dedgstin={selectedGstin} fyear={selectedPeriodSingle} />
        </MuiDialogContent>
      </Dialog>
    </div>
  );
};

export default Table3;
